import React, { useState, useRef, lazy, Component } from 'react';
import { ArrowLeftIcon, PrinterIcon, QrCodeIcon, PlusIcon, MinusIcon } from 'lucide-react';
import { useRestaurant } from '../context/RestaurantContext';
interface QRGeneratorProps {
  onBack: () => void;
}
export function QRGenerator({
  onBack
}: QRGeneratorProps) {
  const {
    restaurant
  } = useRestaurant();
  const appName = restaurant?.name || '';
  const [tableCount, setTableCount] = useState(10);
  const [baseUrl, setBaseUrl] = useState(window.location.origin);
  const printRef = useRef<HTMLDivElement>(null);
  const tables = Array.from({
    length: tableCount
  }, (_, i) => i + 1);
  const getQRUrl = (tableNum: number) => {
    const menuUrl = `${baseUrl}/?table=${tableNum}`;
    return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(menuUrl)}&bgcolor=ffffff&color=000000`;
  };
  const handlePrint = () => {
    window.print();
  };
  return <div className="min-h-screen bg-carbon w-full" data-id="element-408">
      <header className="bg-surface border-b border-gray-800 px-4 py-3 flex items-center justify-between sticky top-0 z-30 print:hidden" data-id="element-409">
        <div className="flex items-center gap-3" data-id="element-410">
          <button onClick={onBack} className="p-2 bg-surface-light rounded-lg text-gray-400 hover:text-white transition-colors border border-gray-700" data-id="element-411">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-412" />
          </button>
          <div className="flex items-center gap-2" data-id="element-413">
            <QrCodeIcon className="w-5 h-5 text-dorado" data-id="element-414" />
            <h1 className="font-heading text-xl text-white" data-id="element-415">
              Generador de QR — Mesas
            </h1>
          </div>
        </div>
        <button onClick={handlePrint} className="flex items-center gap-2 px-4 py-2 bg-dorado text-carbon font-bold rounded-lg active:scale-95 transition-transform" data-id="element-416">
          <PrinterIcon className="w-4 h-4" data-id="element-417" />
          Imprimir QRs
        </button>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-6 print:hidden" data-id="element-418">
        <div className="bg-surface rounded-xl border border-gray-800 p-5 mb-6 space-y-4" data-id="element-419">
          <div data-id="element-420">
            <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-421">
              URL base del menú
            </label>
            <input type="text" value={baseUrl} onChange={e => setBaseUrl(e.target.value)} className="w-full p-3 bg-surface-light border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:ring-2 focus:ring-dorado outline-none text-sm" placeholder="https://tudominio.com" data-id="element-422" />
          </div>
          <div data-id="element-423">
            <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-424">
              Cantidad de mesas
            </label>
            <div className="flex items-center gap-3" data-id="element-425">
              <button onClick={() => setTableCount(Math.max(1, tableCount - 1))} className="p-2 bg-surface-light border border-gray-700 rounded-lg text-gray-400 hover:text-white transition-colors" data-id="element-426">
                <MinusIcon className="w-4 h-4" data-id="element-427" />
              </button>
              <span className="text-white font-bold text-xl w-12 text-center" data-id="element-428">
                {tableCount}
              </span>
              <button onClick={() => setTableCount(Math.min(50, tableCount + 1))} className="p-2 bg-surface-light border border-gray-700 rounded-lg text-gray-400 hover:text-white transition-colors" data-id="element-429">
                <PlusIcon className="w-4 h-4" data-id="element-430" />
              </button>
            </div>
          </div>
        </div>
        <p className="text-xs text-gray-500 mb-4" data-id="element-431">
          Vista previa — cada QR lleva al menú con el número de mesa asignado
        </p>
      </div>

      <div ref={printRef} className="max-w-4xl mx-auto px-4 pb-12 print:max-w-none print:px-0" data-id="element-432">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 print:grid-cols-3 print:gap-6 print:p-8" data-id="element-433">
          {tables.map(num => <div key={num} className="bg-white rounded-xl p-4 flex flex-col items-center gap-2 print:rounded-none print:border print:border-gray-300 print:p-6 print:break-inside-avoid" data-id="element-434">
              <p className="text-black font-bold text-lg print:text-xl" data-id="element-435">
                {appName}
              </p>
              <img src={getQRUrl(num)} alt={`QR Mesa ${num}`} className="w-36 h-36 print:w-44 print:h-44" loading="lazy" data-id="element-436" />
              <p className="text-black font-bold text-2xl print:text-3xl" data-id="element-437">
                Mesa {num}
              </p>
              <p className="text-gray-500 text-xs print:text-sm" data-id="element-438">
                Escaneá para ordenar
              </p>
            </div>)}
        </div>
      </div>

      <style data-id="element-439">{`
        @media print {
          body { background: white !important; }
          .print\\:hidden { display: none !important; }
        }
      `}</style>
    </div>;
}